import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {Show} from '@/store/modules/lib'

interface Style {
  sidebar: object
}

export interface State {
  style: Style,
  contrast: boolean,
  contrastStyle: Style
}

const defaultState: State = {
  style: {
    sidebar: {
      base_text_color: 'red',
      base_background_color: 'white',
    }

  },
  contrast: false,
  contrastStyle: {
    sidebar: {
      base_text_color: 'blue',
      base_background_color: 'grey',
    }
  },

};

const getters = {
  style: (state: State) => {
    return state.contrast ? state.contrastStyle : state.style
  },
  contrast: (state:State) => state.contrast
}

const mutations: MutationTree<State> = {
  changeContrast(state: State) {
    state.contrast = !state.contrast
  }

}


export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations
}
